<app-view-table [dataComplete]="(exportsComplete$ | async)" [dataNoComplete]="(exportsNoComplete$ | async)"
    [configName]="(configName)" [configSize]="(configSize)" (createClick)="createClick()"
    (cancelExport)="cancelExport($event)" (progressExport)="progressExport($event)"
    (downloadExport)="downloadExport($event)" (goToConfigurations)="goToConfigurations()"
    [currentConfig]="(currentConfig$ | async)" (copyConfigClick)="copyConfig($event)"
    (copyExportClick)="copyExport($event)" (viewClick)="viewClick($event)" (editConfigClick)="editConfig($event)"
    (downloadConfigClick)="downloadConfig($event)" (deleteConfigClick)="deleteConfig($event)">
</app-view-table>